<template>
  <app-collapse accordion type="margin">
    <app-collapse-item
      v-for="(faq, index) in faqs"
      :key="index"
      :title="faq.question"
    >
      {{ faq.answer }}
    </app-collapse-item>
  </app-collapse>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
export default {
  components: {
    AppCollapse,
    AppCollapseItem,
  },
  props: {
    faqs: {
       type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
